import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';
import { ShareService } from '../service/share.service';
import { AdminshareService } from "../service/adminshare.service";
import { ActivatedRoute, Router, RouterEvent, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { AViewTextModalComponent } from '../a0106-mail/a-view-text-modal.component';
import { UsersService } from '../service/users.service';
import { Role } from '../app.constant';
import { YoyakuMasterService } from '../service/ymaster.service';
import { startTimeRange } from '@angular/core/src/profile/wtf_impl';
import { state } from '@angular/core/src/animation/dsl';
@Component({
    selector: 'ytimeaxis-app',
    templateUrl: './ytimeaxis.component.html',
    styleUrls: ['ytimeaxis.component.css']
})
export class YTimeaxisComponent implements OnInit {
    title : string = '時間軸';
    isLoaded : boolean = false;
    selected: boolean = false;
    datalist: any = [];
    timeaxis: any =[];
    timeaxis_id:any =[];
    timeaxis_list:any =[];
    all_datalist:any =[];
    all_count:any =[];
    selectedList: any = [];
    selected_timeaxis_list_id: number = null;
    page :number=1;
    languagelist : any = [];
    display_per_page:  number = 5;   /* 最大表示件数 */
    content_list_timeaxis_info: any = {
        'name_name': 'タイトル',
        'name_description': '説明文',
        'name_support': 'タイトルを入力してください',
        'description_support': '説明文を入力してください',
        'data': {},
        'languagelist': [],
        'list_index': 0,
    };
    private previousUrl: string = undefined;
    private currentUrl: string = undefined;
    constructor(
        private commonService: CommonService,
        private shareService: ShareService,
        private adminShareService: AdminshareService,
        public usersService: UsersService,
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
        private yoyakumasterService: YoyakuMasterService,
    ) { }

    ngOnInit(): void {
        this.selected_timeaxis_list_id = +this.route.snapshot.paramMap.get('tid');
        this.getList();
        //画面上部へ移動
        window.scrollTo(0, 0); 
    };

    clearData(): void {
        this.isLoaded = false;
        this.selected = false;
        this.datalist = [];
        this.timeaxis = [];
        this.timeaxis_list = [];
        this.languagelist = [];
        this.content_list_timeaxis_info.list_index = 0;
    }

    getList(): void {
        this.clearData();
        let param ={
            page : this.page,
            display_per_page:this.display_per_page
        };
        this.yoyakumasterService.getTimeaxis(this.selected_timeaxis_list_id)
            .subscribe((res: Response) => {
                if (res["fuel_status"] == "OK") {
                    this.timeaxis_list = res["fuel_results"]["timeaxis_list"];
                    this.content_list_timeaxis_info.languagelist = res["fuel_results"]['language'];
                   
                        if (this.timeaxis_list.length==0){
                        //対象のイベントがないメッセージを表示し、イベント一覧画面へ飛ばす
                        this.commonService.modalOpens(11007,modalresult=>{
                            this.router.navigate(["/ytimeaxis_list"]);
                            });
                            }else{
                            }
        
                    this.all_datalist = res["fuel_results"]["timeaxis"];
                    this.all_count = res["fuel_results"]["all_count"];

                    for (let i = 0; i < this.all_datalist.length; i++) {
                        this.all_datalist[i]['db_selected'] = this.commonService.exchange01toTF(this.all_datalist[i]['selected']);
                        this.all_datalist[i]['disabled'] = this.commonService.exchange01toTF(this.all_datalist[i]['disabled']);
                    }

                    this.isLoaded = true;

                }else if (res["fuel_status"] == "NG") {
                    this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                }else{
                    this.commonService.modalOpens(11003,modalresult=>{});
                }
            },error => {
                this.commonService.modalOpens(error,modalresult=>{});
            });
        }

    
    save(): void {
        this.commonService.modalOpens(50001,
            //保存してもよろしいですか？
            modalresult => {
                if (modalresult == "OK") {
                    this.content_list_timeaxis_info.data.invalid_flg = this.commonService.exchangeTFto01(this.content_list_timeaxis_info.data.invalid_flg);
                    this.yoyakumasterService.saveTimeaxis(this.content_list_timeaxis_info.data)
                        .subscribe((res: Response) => {
                            if (res["fuel_status"] == "OK") {
                                this.commonService.modalOpens(10001, modalresult => { });
                                this.editSelectRowData(undefined,0);
                                this.selected = false;
                                this.page = 1;
                                this.getList();
                            } else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"], modalresult => { });
                            } else {
                                this.commonService.modalOpens(11003, modalresult => { });
                            }
                        }, error => {
                            this.commonService.modalOpens(error, modalresult => { });
                        });
                } else {
                    //
                }
            }
        );
    }
    

    cancel(): void {
        this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                if (modalresult == "OK") {
                    this.editSelectRowData(undefined,0);
                    this.selected = false;
                    this.content_list_timeaxis_info.list_index = 0;
                } else {

                }
            }
        );
    }
    delete(): void {
        this.commonService.modalOpens(50002,
            //削除してもよろしいですか？
            modalresult => {
                if (modalresult == "OK") {
                    this.yoyakumasterService.deleteTimeaxis(this.content_list_timeaxis_info.data)
                        .subscribe((res: Response) => {
                            if (res["fuel_status"] == "OK") {
                                this.commonService.modalOpens(10002, modalresult => {
                                    this.selectedList = this.selectedList.filter(
                                        item =>
                                            item.m_timeaxis_id != this.content_list_timeaxis_info.data.m_timeaxis_id
                                    );
                                    this.editSelectRowData(undefined,0);
                                    this.selected = false;
                                    this.page = 1;
                                    this.getList();
                                });
                            } else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"], modalresult => { });
                            } else {
                                this.commonService.modalOpens(11003, modalresult => { });
                            }
                        }, error => {
                            this.commonService.modalOpens(error, modalresult => { });
                        });
                } else {

                }
            }
        );
    }
    // // 編集
    edit(row: any,index:number): void {
        if (this.selected) {
            this.commonService.modalOpens(50005,
                //編集中の内容を破棄してもよろしいですか？
                modalresult => {
                    if (modalresult == "OK") {
                        this.editSelectRowData(row,index);
                        //画面上部へ移動
                        window.scrollTo(0, 0);

                    } else {
                        return;
                    }
                }
            );
        } else {
            this.editSelectRowData(row,index);
            //画面上部へ移動
            window.scrollTo(0, 0);
        }
    }

    editSelectRowData(row: any, index: number): void {
        if (row == undefined) {
          
            this.selected = true;
            this.content_list_timeaxis_info.data = {
                id: null,
                t_li_id:this.selected_timeaxis_list_id,
                t_start:null,
                t_end:null,
                invalid_flg: false,
                count:null,
                sort: null,
                delete_flg:null,
                update_datetime: null,
                content: [
                    {
                        id:null,
                        m_language_id: null,
                        language_letter:null,
                        title_name: null,
                        content: null,
                    }
                ],
            };
                //新規の時、保存データが１つでもある場合は、1行目の言語を入れる
                if(this.all_datalist.length>0){
                    this.content_list_timeaxis_info.list_index = 1
                    for( let i=0;i<this.all_datalist[0].content.length; i++){
                        this.content_list_timeaxis_info.data.content[i]=
                        {
                            id:null,
                            m_language_id: this.all_datalist[0].content[i].m_language_id,
                            language_letter:this.all_datalist[0].content[i].language_letter,
                            title_name: this.all_datalist[0].content[i].title_name,
                            content: null,
                        }

                    }
                }
                
            } else {
            this.selected = true;
            this.content_list_timeaxis_info.data = JSON.parse(JSON.stringify(row));
            this.content_list_timeaxis_info.data.invalid_flg = this.commonService.exchange01toTF(this.content_list_timeaxis_info.data.invalid_flg);
                    //編集時、1行以上かつデータが1件以上で制御
                    if(index>0 || this.all_datalist.length>1){
                        this.content_list_timeaxis_info.list_index = 1
                        
                    }
                }             
        }     
    upRow(row: number, data: any): void {
        let tempdatalist;
        tempdatalist = this.all_datalist;

        if (row == 0) {//最初

        } else {
            //自分のレコード　myRecord
            let myRecord = tempdatalist[row];
            //１つ前のレコード beforeRecord
            let beforeRecord = tempdatalist[row - 1];
            // 旧sortを退避
            myRecord['chk_sort'] = myRecord['sort'];
            beforeRecord['chk_sort'] = beforeRecord['sort'];

            //sortnoを交換する
            let tmpsort = myRecord['sort'];
            myRecord['sort'] = beforeRecord['sort'];
            beforeRecord['sort'] = tmpsort;

            //２レコードをUPDATEする　myRecord,beforeRecord
            this.yoyakumasterService.changeOrderTimeaxis([myRecord, beforeRecord])
                .subscribe((res: Response) => {
                    if (res["fuel_status"] == "OK") {
                        tempdatalist.splice(row - 1, 2, tempdatalist[row], tempdatalist[row - 1]);
                    } else if (res["fuel_status"] == "NG") {
                        this.commonService.modalOpens(res["fuel_message"], modalresult => { });
                    } else {
                        this.commonService.modalOpens(11003, modalresult => { });
                    }
                }, error => {
                    this.commonService.modalOpens(error, modalresult => { });
                });
        }
    }
    downRow(row: number, data: any): void {
        let tempdatalist;
        tempdatalist = this.all_datalist;

        if (row == tempdatalist.length - 1) {//最終

        } else {
            //１つ後ろのレコード afterRecord
            let afterRecord = tempdatalist[row + 1];
            //自分のレコード　myRecord
            let myRecord = tempdatalist[row];
            // 旧sortを退避
            myRecord['chk_sort'] = myRecord['sort'];
            afterRecord['chk_sort'] = afterRecord['sort'];
            //sortnoを交換する
            let tmpsort = myRecord['sort'];
            myRecord['sort'] = afterRecord['sort'];
            afterRecord['sort'] = tmpsort;

            //２レコードをUPDATEする　myRecord,afterRecord
            this.yoyakumasterService.changeOrderTimeaxis([myRecord, afterRecord])
                .subscribe((res: Response) => {
                    if (res["fuel_status"] == "OK") {
                        tempdatalist.splice(row, 2, tempdatalist[row + 1], tempdatalist[row]);
                    } else if (res["fuel_status"] == "NG") {
                        this.commonService.modalOpens(res["fuel_message"], modalresult => { });
                    } else {
                        this.commonService.modalOpens(11003, modalresult => { });
                    }
                }, error => {
                    this.commonService.modalOpens(error, modalresult => { });
                });
        }
    }
    check() {
        if (this.selected == true) {
            return true
        } else {
            return false
        }
    }
    checkList(start:string,end:string): boolean {

        var tempList = this.content_list_timeaxis_info.data;
        var row = tempList.content.filter(
            item =>
                item.m_language_id == null
                || item.content == null
                || item.content == ""
                || item.content.length > 50
        );
        if (row.length > 0) {
            return true;
        }
        if(start==null || start=="" || end==null || end==""){
            return true;
        }
       
        //言語数以上登録されていないか
        if (this.content_list_timeaxis_info.languagelist.length < tempList.content.length) {
            return true;
        } else {
            //TODO 言語IDが複数ないか
            let dupcheckList = this.commonService.checkDuplicateRecords(tempList.content,'m_language_id');
            if (dupcheckList.length < tempList.content.length){
                return true;
            }else{
                return false;
            }
        }
    }
    goBack(): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                            this.location.back();
                    }
                }
            );
        }else{
                this.location.back();
        }
    }
   
}



// WEBPACK FOOTER //
// ./src/app/a2122-ytimeaxis/ytimeaxis.component.ts